<script>
  import Multiselect from 'vue-multiselect'
  import {relations} from "../router/datasets/RelationshipDataClass";
  import {VueTelInput} from 'vue-tel-input'
  import PictureInput from '@/components/PictureInput'

  export default {
    props: { self: Boolean, member: Object },

    components: {
      Multiselect,
      VueTelInput,
      PictureInput
    },

    data () {
      return {
        industries: [],
        tags: [],
        relations: relations
      }
    },

    created() {
      this.callAPI({
        endpoint: `/industries/getAll`,
        type: 'get',
        successCallback: (response) => {
          this.industries = response.data;
        }
      });

      this.callAPI({
        endpoint: `/tags/getAll`,
        type: 'get',
        successCallback: (response) => {
          this.tags = response.data;
        }
      });

      if(this._.has(this.member,'relation')) {
        this.$set(this.member,'relationship_name',
                {
                  value: this.member.relation[0] + ',' + this.member.relation[1],
                  name: this.member.relation[0] + ' -> ' + this.member.relation[1]
                }
        );
      }
    },

    methods: {

      deleteMedia() {
        this.callAPI({
          endpoint: `/members/${this.member.id}/media/delete`,
          type: 'delete',
          successCallback: (response) => {
            this.member.profile_picture = null
          }
        });
      },

      addColumn() {
        if(this._.has(this.member,'columns')) {
          this.member.columns.push({key:null, value:null})
        } else {
          // Ask parent to create custom col. property on member.
          this.$emit('createCustomColumn')
        }
      },
      popColumn(index) {
        this.member.columns.splice(index, 1);
      },
      addIndustry (newTag) {
        const tag = {
          name: newTag,
          code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
        }
        this.options.push(tag)
        this.value.push(tag)
      },

      pictureUpdated:  function(image) {
        if (image) {
          this.member.profile_picture = image;
          this.member.profile_updated=true;
        }
      },

      pictureRemoved: function() {
        this.member.profile_picture=null;
        this.member.profile_updated=true;
      },

      flashImage: function() {
        this.$swal({
          imageUrl: this.member.profile_picture,
          showConfirmButton: false
        });
      }
    }
  }
</script>

<template>
  <form>
    <b-row class="mb-4" v-if="self==false">
      <b-col md="2">
        <label>Who?</label>
      </b-col>
      <b-col md="10">
        <multiselect
                v-model="member.relationship_name"
                placeholder="Relationship Type"
                label="name"
                track-by="value"
                :options="relations">
        </multiselect>
      </b-col>
    </b-row>

    <b-row class="mb-4">
      <b-col md="2">
        <label>Profile Picture</label><br>
        <small class="text-muted">(Jpg or png)</small>
      </b-col>
      <b-col md="4">

        <picture-input
                ref="pictureInput"
                :crop="false"
                :removable="true"
                height="110"
                width="100"
                button-class="btn"
                :prefill="member.profile_picture"
                :accept="'image/*'"
                :alertOnError="false"
                :zIndex="1"
                @remove="pictureRemoved"
                @change="pictureUpdated">
        </picture-input>

      </b-col>
    </b-row>

    <b-row class="mb-4">
      <b-col md="2">
        <label class="required">First Name</label>
      </b-col>
      <b-col md="10">
        <b-form-input v-model="member.first_name" name="first_name" placeholder="Enter first name"></b-form-input>
      </b-col>
    </b-row>

    <b-row class="mb-4">
      <b-col md="2">
        <label>Middle Name</label>
      </b-col>
      <b-col md="10">
        <b-form-input v-model="member.middle_name" name="middle_name" placeholder="Enter middle name"></b-form-input>
      </b-col>
    </b-row>

    <b-row class="mb-4">
      <b-col md="2">
        <label class="required">Last Name</label>
      </b-col>
      <b-col md="10">
        <b-form-input v-model="member.last_name" name="last_name" placeholder="Enter last name"></b-form-input>
      </b-col>
    </b-row>

    <b-row class="mb-4">
      <b-col md="2">
        <label class="required">Gender</label>
      </b-col>
      <b-col md="10">
        <select v-model="member.gender" name="gender" class="custom-select">
          <option value="Male">Male</option>
          <option value="Female">Female</option>
        </select>
      </b-col>
    </b-row>

    <b-row class="mb-4">
      <b-col md="2">
        <label class="required">Date of birth</label>
      </b-col>
      <b-col md="10">
        <input v-model="member.dob" name="dob" v-mask="'##/##/####'" type="text" class="form-control" />
        <span class="text-muted">"dd/mm/yyyy"</span>
      </b-col>
    </b-row>

    <b-row class="mb-4">
      <b-col md="2">
        <label class="required">Marital Status</label>
      </b-col>
      <b-col md="10">
        <select v-model="member.marital_status" name="marital_status" class="custom-select">
          <option value="Unmarried">Unmarried</option>
          <option value="Married">Married</option>
          <option value="Divorced">Divorced</option>
        </select>
      </b-col>
    </b-row>

    <b-row class="mb-4">
      <b-col md="2">
        <label>Industry</label>
      </b-col>
      <b-col md="10">
        <multiselect
                v-model="member.industries"
                tag-placeholder="Add new industry"
                placeholder="Add new industry"
                label="name"
                track-by="id"
                :options="industries" :multiple="true" :taggable="true" @tag="addIndustry">
        </multiselect>
      </b-col>
    </b-row>

    <b-row class="mb-4" v-if="$store.getters.isLoggedIn">
      <b-col md="2">
        <label>Tags</label>
      </b-col>
      <b-col md="10">
        <multiselect
                v-model="member.tags"
                tag-placeholder="Tags"
                placeholder="Add new tag"
                label="name"
                track-by="id"
                :options="tags" :multiple="true" :taggable="true">
        </multiselect>
      </b-col>
    </b-row>

    <b-row class="mb-4">
      <b-col md="2">
        <label>Occupation</label>
      </b-col>
      <b-col md="10">
        <b-form-input v-model="member.occupation" name="occupation" placeholder="Enter Occupation"></b-form-input>
      </b-col>
    </b-row>

    <b-row class="mb-4">
      <b-col md="2">
        <label class="required">Email Address</label>
      </b-col>
      <b-col md="10">
        <b-form-input v-model="member.email" name="email" placeholder="Enter email"></b-form-input>
      </b-col>
    </b-row>

    <b-row class="mb-4">
      <b-col md="2">
        <label class="required">Mobile Number</label>
      </b-col>
      <b-col md="10">
        <vue-tel-input v-model="member.mobile_number"></vue-tel-input>
      </b-col>
    </b-row>

    <b-row class="mb-4">
      <b-col md="2">
        <label class="required">Whatsapp Number</label>
      </b-col>
      <b-col md="10">
        <vue-tel-input v-model="member.whatsapp_number"></vue-tel-input>
      </b-col>
    </b-row>

    <div v-if="$store.getters.isLoggedIn">
      <div v-if="this._.has(this.member,'columns')">
        <b-row class="mb-4" v-for="(column,index) in this.member.columns" :key="column.id">
          <b-col md="4">
            <b-form-input placeholder="Enter Key" v-model="column.key"></b-form-input>
          </b-col>
          <b-col md="5">
            <b-form-input placeholder="Enter Value" v-model="column.value"></b-form-input>
          </b-col>
          <b-col md="3">
            <button @click="popColumn(index)" class="btn btn-outline-danger btn-sm" type="button">
              <i class="fa fa-minus mr-1"></i>
              Remove
            </button>
          </b-col>
        </b-row>
      </div>

      <button @click="addColumn" class="btn btn-primary mr-2" type="button">
        <i class="mdi mdi-plus"></i>
        Add Custom Column
      </button>
    </div>

  </form>
</template>
